/**
 * Admin Role Configuration
 *
 * This file defines which registeredRole values have admin access.
 *
 * Registered Roles:
 * 0 = Admin (System Administrator)
 * 1 = Student
 * 2 = Professional
 * 3 = Institution
 * 4 = Organization
 * 5 = Autodidact
 *
 * Update ADMIN_ROLES array to specify which roles should have admin access.
 * You can add multiple roles if needed, e.g., [0, 3] for Admin and Institution.
 */

export const ADMIN_ROLE_VALUE = 0; // Admin role value
export const ADMIN_ROLES = [ADMIN_ROLE_VALUE]; // Admin role

export const isAdminRole = (registeredRole: number | null | undefined): boolean => {
  if (registeredRole === null || registeredRole === undefined) {
    return false;
  }
  return ADMIN_ROLES.includes(registeredRole);
};
